var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import deepmerge from 'deepmerge';
export function createInheritedProvider(ContextComponent, merge) {
  return function (props) {
    var existingProps = React.useContext(ContextComponent) || {};
    var _a = props.value,
      value = _a === void 0 ? {} : _a,
      children = props.children;
    var mergeStrategy = merge || 'deep';
    /* @ts-ignore */
    return React.createElement(ContextComponent.Provider, {
      value: mergeStrategy === 'deep' ? deepmerge(existingProps, value) : __assign(__assign({}, existingProps || {}), value)
    }, children);
  };
}
;